import React, {useState} from "react";
import Header from "../components/Header";

const Formwork = () => {
const [selectedOption, setSelectedOption] = useState('column');
  const [length, setLength] = useState(0);
  const [breadth, setBreadth] = useState(0);
  const [width, setWidth] = useState(0);
  const [Quantity, setQuantity] = useState(0);
  const [result, setResult]= useState('');
  const [plank, setPlank]= useState('');
   const [showResult, setShowResult] = useState(false);

  const handleRadioChange =(e)=>{
    setSelectedOption(e.target.value);
    setResult(0);
     setShowResult(false);
}



    const calculateBeamFormwork = ()=>{
      if (!length || !breadth ||  !width || !Quantity){
      alert(" Please fill all the fields");
      return;
    }
  // Add your calculation logic
   const nwLength = parseFloat(length);
        const nwBreadth = parseFloat(breadth);
        const nwWidth=parseFloat(width);
        let NL = (nwLength *1000)/3000;
    let NB = 0;
    let NH = 0;


  if (breadth>= 0.225 || breadth <= 0.3){
        NB = 1
      
    }
    else if (breadth> 0.300 || breadth <= 0.45) {
       NB = 2;
        
    } 
    else if (breadth> 0.450 || breadth <= 0.59){
        NB = 2
   
    }
    else if (breadth > 0.6 || breadth <= 0.75){
       NB = 3
      
    }
    else if (breadth > 0.75) {
       NB = 3
      
    }
    else{
       
        alert('Invalid input!!!, breadth is either Bigger too bigger or is less than thickness of Blockwork');
    
    }
 

      if (width>= 0.225 || width <= 0.300){
            NH= 1
       
    }
    else if (width > 0.300 || width <= 0.450) {
       NH = 2;
   
    } 
    else if (width > 0.450 || width <= 0.600){
       NH = 2;
   
    }
    else if (width > 0.600 || width <= 0.750){
        NH = 3;
   
    }
    else if (width > 0.750) {
       NH = 3;
   
    }
    
    else{alert('Invalid input!!!, Width is either too bigger or less than thickness of block');
    
    
    }


     NL = Math.round(NL);
    
      

    const NHT = 2*(NH +NB);
   
    
const finalCompute = NHT * NL;

    const percent = 0.2 * finalCompute;
  const quantityIncld = finalCompute + percent;
 const display = quantityIncld* parseFloat(Quantity);

 // for brazing 
const brazeLengthN = nwLength/0.45;
const brazePerimeter = 2*(nwWidth + nwBreadth + 0.05);
const braze = brazeLengthN * brazePerimeter;
const brazeQ = braze * parseFloat(Quantity);
const brazePieces = brazeQ/3;
  
setResult({
display:display,
brazeQ:brazeQ.toFixed(0),
brazePieces:brazePieces.toFixed(0)

    });
    setShowResult(true);
}


      const calculateColumnFormwork = ()=>{
         if (!length || !breadth ||  !width || !Quantity){
      alert(" Please fill all the fields");
      return;
    }

      const nwLength = parseFloat(length);
        const nwBreadth = parseFloat(breadth);
        const nwWidth=parseFloat(width);

        let NL = (nwLength *1000)/3000;

   let NB = 0;
    let NH = 0;


  if (breadth>= 0.225 || breadth <= 0.3){
        NB = 1
      
    }
    else if (breadth> 0.300 || breadth <= 0.45) {
       NB = 2;
        
    } 
    else if (breadth> 0.450 || breadth <= 0.59){
        NB = 2
   
    }
    else if (breadth > 0.6 || breadth <= 0.75){
       NB = 3
      
    }
    else if (breadth > 0.75) {
       NB = 3
      
    }
    else{
       
        alert('Invalid input!!!, breadth is either Bigger too bigger or is less than thickness of Blockwork');
    
    }
 

      if (width>= 0.225 || width <= 0.300){
            NH= 1
       
    }
    else if (width > 0.300 || width <= 0.450) {
       NH = 2;
   
    } 
    else if (width > 0.450 || width <= 0.600){
       NH = 2;
   
    }
    else if (width > 0.600 || width <= 0.750){
        NH = 3;
   
    }
    else if (width > 0.750) {
       NH = 3;
   
    }
    
    else{alert('Invalid input!!!, Width is either too bigger or less than thickness of block');
    
    
    }


    
    NL = Math.round(NL);
   

    const NpT = 2*(NH +NB);
   
    
const finalCompute = NpT * NL;
  const percent = 0.2 * finalCompute;
  const quantityIncld = finalCompute + percent;
 const display = quantityIncld* parseFloat(Quantity);

// for brazing 
const brazeLengthN = nwLength/0.45;
const brazePerimeter = 2*(nwWidth + nwBreadth + 0.05);
const braze = brazeLengthN * brazePerimeter;
const brazeQ = braze * parseFloat(Quantity);
const brazePieces = brazeQ/3;
    
    setResult({
display:display,
brazeQ:brazeQ.toFixed(0),
brazePieces:brazePieces.toFixed(0)
    });
    setShowResult(true);
      }

//slab formwork
      const calculateSlabFormwork = ()=>{
         if (!length || !breadth){
      alert(" Please fill all the fields");
      return;
    }
          const L = parseFloat(length);
    const B = parseFloat(breadth);

   let lengthSForm, breadthSForm, totalPlankform, slabPercent, displaySWork,displaySSWork, slabFBrazing, slabBrazePercent,
    totalSlabFinalBrazing, verticalStanding, horizontalStanding, totalSTanding, addPercentStanding, fiinalTotalStanding;
   
       document.getElementById("plankResults").style.display =
        plank === "plank" ? "block" : "none";
    document.getElementById("gypsumResults").style.display =
        plank === "gypsum" ? "block" : "none";
           
if (plank==="plank"){
  

lengthSForm = (L * 1000)/3000;
breadthSForm =(B*1000)/200;
totalPlankform= lengthSForm * breadthSForm;

slabPercent= 0.1 * totalPlankform;
displaySWork = totalPlankform + slabPercent;
// for brazing 2 x 3 plank
slabFBrazing = (L/ 0.600) * B;
slabBrazePercent = 0.1 * slabFBrazing;
totalSlabFinalBrazing = (slabFBrazing + slabBrazePercent)/2.4;
//for standing Plank or Bamboo
verticalStanding = L/0.600;
horizontalStanding = B/0.600;
totalSTanding = verticalStanding * horizontalStanding;
addPercentStanding = 0.1 * totalSTanding;
fiinalTotalStanding = totalSTanding + addPercentStanding;
  setResult({
displaySWork:displaySWork.toFixed(0),
totalSlabFinalBrazing:totalSlabFinalBrazing.toFixed(0),
fiinalTotalStanding:fiinalTotalStanding.toFixed(0)
    });
      

}
else if (plank==="gypsum"){

    lengthSForm = (L * 1000)/2400;
    breadthSForm =(B*1000)/1200;
    totalPlankform= lengthSForm * breadthSForm;
    
    slabPercent= 0.1 * totalPlankform;
    displaySSWork = totalPlankform + slabPercent;
    
    // for brazing 2 x 3 plank
    slabFBrazing = (L/ 0.600) * B;
    slabBrazePercent = 0.1 * slabFBrazing;
    totalSlabFinalBrazing = (slabFBrazing + slabBrazePercent)/2.4;
    
    //for standing Plank or Bamboo
    verticalStanding = L/0.600;
    horizontalStanding = B/0.600;
    totalSTanding = verticalStanding * horizontalStanding;
    addPercentStanding = 0.1 * totalSTanding;
    fiinalTotalStanding = totalSTanding + addPercentStanding;
    
    setResult({
displaySSWork:displaySSWork.toFixed(0),
totalSlabFinalBrazing:totalSlabFinalBrazing.toFixed(0),
fiinalTotalStanding:fiinalTotalStanding.toFixed(0)
    });
    
}
 else if(plank==='Select'){
  setResult(0);
 }     
      }
    return ( 
   <div>
    <Header/>
   
        <div className="formwork-container">

          
          <fieldset className="form-toggle">
        <legend>Formwork Estimation</legend>
    
   
     {/* Toggle Section */}
     <div className="form-toggle-contain">
       <input type="radio" id="columnFormwork" name="formworkToggle" value="column"  checked={selectedOption === 'column'} onChange={handleRadioChange}  />
       <label htmlFor="columnFormwork">Column Formwork</label>
   
       <input type="radio" id="beamFormwork" name="formworkToggle" value="beam"  checked={selectedOption === 'beam'} onChange={handleRadioChange} />
       <label htmlFor="beamFormwork">Beam Formwork</label>
   
       <input type="radio" id="slabFormwork" name="formworkToggle" value="slab"  checked={selectedOption === 'slab'} onChange={handleRadioChange} />
       <label htmlFor="slabFormwork">Slab Formwork</label>
     </div> </fieldset>
   
     {/* Column Form */}
    {selectedOption === 'column' &&  <div className="form-content">
       <fieldset>
       <h2>Column Formwork</h2>
       
         <label htmlFor="columnHeight">Height of Column (m):</label>
         <input type="number" id="columnHeight" name="columnHeight" onChange={(e)=> setLength(e.target.value)} required />
   
         <label htmlFor="columnWidth">Length of Column (m):</label>
         <input type="number" id="columnWidth" name="columnWidth" onChange={(e)=> setWidth(e.target.value)} required />
   
         <label htmlFor="columnBreadth">Breadth of Column (m):</label>
         <input type="number" id="columnBreadth" name="columnBreadth" onChange={(e)=> setBreadth(e.target.value)} required />
   
    <label htmlFor="columnBreadth">Quantity of Column Formwork:</label>
         <input type="number" id="columnBreadth" name="columnBreadth" onChange={(e)=> setQuantity(e.target.value)} required />
   
         <button type="button" onClick={calculateColumnFormwork}>Submit</button>

     <div className="columnPlankResult">
      
         <p>Total  1 x 12 (0.25m x 3.2m) Planks needed: <span id="beamResult"> <strong>{result.display} </strong> Piece/Pieces</span></p>
     <p>Total brazing Length required: <span id="beamResult"><strong>{result.brazeQ}</strong> m</span></p>
      <p>Total number of  (3m )  brazing planks to buy : <span id="beamResult"><strong>{result.brazePieces}</strong> Piece/Pieces</span></p>
     <p>10% contigency has been included for 1 x 12 Planks</p>
     </div> 
     </fieldset>

     </div>
}
     {/* Beam Form */}
   {selectedOption === 'beam' &&   <div id="beamForm" className="form-content" >
       <h2>Beam Formwork</h2>
       <fieldset>
         <label htmlFor="beamWidth">Length of Beam (m):</label>
         <input type="number" id="beamWidth" name="beamWidth" onChange={(e)=> setLength(e.target.value)} required />
   
         <label htmlFor="beamBreadth">Breadth of Beam (m):</label>
         <input type="number" id="beamBreadth" name="beamBreadth" onChange={(e)=> setBreadth(e.target.value)} required />
   
         <label htmlFor="beamHeight">Height of Beam (m):</label>
         <input type="number" id="beamHeight" name="beamHeight" onChange={(e)=> setWidth(e.target.value)} required />
   
   <label htmlFor="columnBreadth">Quantity of Beam FormWork:</label>
         <input type="number" id="columnBreadth" name="columnBreadth" onChange={(e)=> setQuantity(e.target.value)} required />
   
         <button type="button" onClick={calculateBeamFormwork}>Submit</button>
       
        <div className="beamPlankResult">
       <p>Total 1 x 12 (0.25m x 3.2m) Planks needed: <span id="beamResult"><strong>{result.display}</strong> Piece/Pieces</span></p>
     <p>Total brazing Length required: <span id="beamResult"><strong>{result.brazeQ}</strong> m</span></p>
      <p>Total number of  (3m )  brazing planks to buy : <span id="beamResult"><strong>{result.brazePieces}</strong> Piece/Pieces</span></p>
     <p>10% contigency has been included for 1 x 12 Planks</p>
    </div> 
    </fieldset>
    </div>
  
}
     {/* Slab Form */}
    {selectedOption === 'slab' &&  <div  className="form-content" >
       <h2>Slab Formwork</h2>
       <fieldset>
         <label htmlFor="slabLength">Length of Slab (m):</label>
         <input type="number" id="slabLength" name="slabLength" onChange={(e)=> setLength(e.target.value)} required />
   
         <label htmlFor="slabBreadth">Breadth of Slab (m):</label>
         <input type="number" id="slabBreadth" name="slabBreadth" onChange={(e)=> setBreadth(e.target.value)} required />
   
        
         <label htmlFor="materialType">Select Material:</label>
         <select id="materialType" name="materialType" onChange={(e)=> setPlank(e.target.value)} required>
           <option value="select">Select</option>
           <option value="plank">1 x 12 Plank</option>
           <option value="gypsum">Gypsum Board</option>
         </select>
   
         <button type="button" onClick={calculateSlabFormwork}>Submit</button>
     
     </fieldset>




 {/* Result Popup */}
      {showResult && (
        <div className="result-wrapper" onClick={() => setShowResult(false)}>
          <div className="result-display" onClick={(e) => e.stopPropagation()}>
            <div className="close-result" onClick={() => setShowResult(false)}>X</div>
             {selectedOption === 'beam' ? (
       <div className="columnPlankResult">  
         <p>Total number of 1 x 12 (0.25 x 3.2) Plank is: <span id="beamResult"> <strong>{result.display} </strong> Piece/Pieces</span></p>
     <p>Total brazing Length is: <span id="beamResult"><strong>{result.braze}</strong> m</span></p>
      <p>Total number of  (3m )  brazing planks to buy : <span id="beamResult"><strong>{result.brazePieces}</strong> Piece/Pieces</span></p>
      <p>10% contigency has been included for 1 x 12 Planks</p>
     </div> ):(
<div className="columnPlankResult">  
         <p>Total number of 1 x 12 (0.25 x 3.2) Plank is: <span id="beamResult"> <strong>{result.display} </strong> Piece/Pieces</span></p>
     <p>Total brazing Length is: <span id="beamResult"><strong>{result.braze}</strong> m</span></p>
      <p>Total number of  (3m )  brazing planks to buy : <span id="beamResult"><strong>{result.brazePieces}</strong> Piece/Pieces</span></p>
    <p>10% contigency has been included for 1 x 12 Planks</p>
     </div>
     )}
</div></div>
)}

       <div id="plankResults" style={{ display: 'none' }}>
         <p>Total  1 x 12(0.25m x 3.2m) Plank needed: <span id="plankCount"><strong>{result.displaySWork}</strong></span></p>
           <p>Total brazing Length of 2 x 3 Plank (3m each) required: <span id="plank23Count"><strong>{result.totalSlabFinalBrazing}</strong></span></p>
         <p>Total number of Standing Bamboo (3m High) : <span id="plankBambooCount"><strong>{result.fiinalTotalStanding}</strong></span></p>
      <p>10% contigency has been included for 1 x 12 Planks, Brazing and Standing Bamboo</p>
       </div>
   
       <div id="gypsumResults" style={{ display: 'none' }}>
             <p>Total number of Gypsum Board needed: <span id="gypsumCount"><strong>{result.displaySSWork}</strong></span></p>
         <p>Total brazing Length of 2 x 3 Plank (3m each) required: <span id="plank23Count"><strong>{result.totalSlabFinalBrazing}</strong></span></p>
         <p>Total number of Standing Bamboo (3m High): <span id="plankBambooCount"><strong>{result.fiinalTotalStanding}</strong></span></p>
  <p>10% contigency has been included for Gypsum Board, Brazing and Standing Bamboo</p>
       </div>
<div id="emptyResults" style={{ display: 'none' }}>
       
       </div>




     </div>
}
   </div>
   </div>
     );
};
 
export default Formwork;